<template>
  <div>
    <label v-if="label">
      <StrongText>{{ label }}</StrongText>
    </label>
    <div class="group">
      <ul>
        <li :style="style.text">
          <div :style="style.square" class="square"></div>
          <span>Feminino</span>
        </li>
        <li :style="style.text">
          <div :style="style.square" class="square"></div>
          <span>Masculino</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FormElementStyle from '@/components/FormElementStyle'
import StrongText from '@/components/StrongText'
import colors from '@/services/colors'

export default {
  name: 'CheckGender',
  props: {
    label: String,
  },
  components: {
    StrongText,
    FormElementStyle,
  },
  computed: {
    style() {
      return {
        text: {
          color: colors.blue
        },
        square: {
          border: `1px solid ${colors.blue}`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.group {
  margin-top: 11px;
  margin-bottom: 60px;
}
.square {
  border: 1px solid;
  background: #fff;
  height: 24px;
  width: 24px;
  display: inline-block;
  margin-right: 8px;
}
ul {

}
li {
  display: inline-block;
  margin-right: 50px;
  font-size: 15px;
  &:last-child {
    margin-right: 0;
  }
  span {
    position: relative;
    top: -6px;
    font-weight: 400;
  }
}
</style>
